<template>
    <div @mouseleave="! readonly && (hoveredRaiting = null)">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                v-for="index in iterator" :key="index"
                @mouseenter="! readonly && (hoveredRaiting = index)"
                @click="! readonly && (rating = index)"
                class="inline-block fill-current" :class="{
                    'text-accented': isHighlighted(index),
                    'text-gray-300': ! isHighlighted(index),
                    'cursor-pointer': ! readonly
                }">
                <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
            </svg>
            <input type="hidden" :name="name" :value="rating || ''"/>
    </div>
</template>

<script>
export default {

    props: {
        name: {
            required: true
        },
        value: {
            default: null
        },
        readonly: {
            default: false
        }
    },

    data() {
        return {
            iterator: [1,2,3,4,5],
            rating: this.value,
            hoveredRaiting: null
        }
    },

    methods: {
        isHighlighted(index) {
            if (this.hoveredRaiting) {
                return index <= this.hoveredRaiting;
            }

            return index <= this.rating;
        }
    }

}
</script>
